import { render, staticRenderFns } from "./GooglePay.vue?vue&type=template&id=2f903ba2&scoped=true"
import script from "./GooglePay.vue?vue&type=script&lang=js"
export * from "./GooglePay.vue?vue&type=script&lang=js"
import style0 from "./GooglePay.vue?vue&type=style&index=0&id=2f903ba2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f903ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f903ba2')) {
      api.createRecord('2f903ba2', component.options)
    } else {
      api.reload('2f903ba2', component.options)
    }
    module.hot.accept("./GooglePay.vue?vue&type=template&id=2f903ba2&scoped=true", function () {
      api.rerender('2f903ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/Pay/component/GooglePay.vue"
export default component.exports